//数据处理--事前
export function beforeSpanMethod(detail) {
    let list = [];
    detail.map((detailItem,detailIndex)=> {
        let totalPrice = 0;
        detailItem.laborItemList.map(item => {
            totalPrice+= Number(item.unitSumPrice)
        })
        detailItem.machineItemList.map(item => {
            totalPrice+= Number(item.unitSumPrice)
        })
        detailItem.materialItemList.map(item => {
            totalPrice+= Number(item.unitSumPrice)
        })
        detailItem.otherItemList.map(item => {
            totalPrice+= Number(item.unitSumPrice)
        })
        detailItem.total_Price = totalPrice == 0? 0:(totalPrice).toFixed(2)  //合计-合计
        detailItem.unit_Price = totalPrice == 0? '':(totalPrice/ detailItem.checkCount).toFixed(2) //合计-单价
        // 比较数据的长度取最大值
        let obj = {
            laborItemList: detailItem.laborItemList,
            machineItemList: detailItem.machineItemList,
            materialItemList: detailItem.materialItemList,
            otherItemList: detailItem.otherItemList,
        }
        let objIndex = '';
        for (let x in obj){
            if (objIndex == '' || obj[x].length > obj[objIndex].length){
                objIndex = x;
            }
        }
        if(detailItem[objIndex].length != 0){
            detailItem[objIndex].map((arrItem, arrIndex)=> {
                list.push({
                    'index':detailIndex,
                    'subIndex':arrIndex,
                    'approveStatus': detailItem.approveStatus,
                    'approveStatusDisplayName': detailItem.approveStatusDisplayName,
                    "id": detailItem.id,
                    "generalContractProjectDetailsId": detailItem.generalContractProjectDetailsId,
                    "projectId": detailItem.projectId,
                    "dictId": detailItem.dictId,
                    "unitPrice": detailItem.unitPrice,
                    "contractCount": detailItem.contractCount,
                    "contractSumPrice": detailItem.contractSumPrice,
                    "checkCount": detailItem.checkCount,
                    "checkSumPrice": detailItem.checkSumPrice,
                    "subCategoryNo": detailItem.subCategoryNo,
                    "subCategoryName": detailItem.subCategoryName,
                    "unit": detailItem.unit,
                    "total_Price": detailItem.total_Price,
                    "unit_Price": detailItem.unit_Price,

                    laborItem_remark: arrIndex>detailItem.laborItemList.length-1? '':detailItem.laborItemList[arrIndex].remark,    //备注
                    laborItem_subCategoryName: arrIndex>detailItem.laborItemList.length-1? '':detailItem.laborItemList[arrIndex].subCategoryName,//细目名称
                    laborItem_subCategoryNo: arrIndex>detailItem.laborItemList.length-1? '':detailItem.laborItemList[arrIndex].subCategoryNo, //细目编号
                    laborItem_unit: arrIndex>detailItem.laborItemList.length-1? '':detailItem.laborItemList[arrIndex].unit,  //单位
                    laborItem_unitCount: arrIndex>detailItem.laborItemList.length-1? '':detailItem.laborItemList[arrIndex].unitCount,//数量
                    laborItem_unitPrice: arrIndex>detailItem.laborItemList.length-1? '':detailItem.laborItemList[arrIndex].unitPrice, //单价
                    laborItem_unitSumPrice: arrIndex>detailItem.laborItemList.length-1? '':detailItem.laborItemList[arrIndex].unitSumPrice, //合价

                    machineItem_remark: arrIndex>detailItem.machineItemList.length-1? '':detailItem.machineItemList[arrIndex].remark,    //备注
                    machineItem_subCategoryName: arrIndex>detailItem.machineItemList.length-1? '':detailItem.machineItemList[arrIndex].subCategoryName,//细目名称
                    machineItem_subCategoryNo: arrIndex>detailItem.machineItemList.length-1? '':detailItem.machineItemList[arrIndex].subCategoryNo, //细目编号
                    machineItem_unit: arrIndex>detailItem.machineItemList.length-1? '':detailItem.machineItemList[arrIndex].unit,  //单位
                    machineItem_unitCount: arrIndex>detailItem.machineItemList.length-1? '':detailItem.machineItemList[arrIndex].unitCount,//数量
                    machineItem_unitPrice: arrIndex>detailItem.machineItemList.length-1? '':detailItem.machineItemList[arrIndex].unitPrice, //单价
                    machineItem_unitSumPrice: arrIndex>detailItem.machineItemList.length-1? '':detailItem.machineItemList[arrIndex].unitSumPrice, //合价

                    materialItem_remark: arrIndex>detailItem.materialItemList.length-1? '':detailItem.materialItemList[arrIndex].remark,    //备注
                    materialItem_productName: arrIndex>detailItem.materialItemList.length-1? '':detailItem.materialItemList[arrIndex].productName,// 存货名称
                    materialItem_productNumber: arrIndex>detailItem.materialItemList.length-1? '':detailItem.materialItemList[arrIndex].productNumber, //存货编码
                    materialItem_model: arrIndex>detailItem.materialItemList.length-1? '':detailItem.materialItemList[arrIndex].model, //规格型号
                    materialItem_unit: arrIndex>detailItem.materialItemList.length-1? '':detailItem.materialItemList[arrIndex].unit,  //单位
                    materialItem_unitCount: arrIndex>detailItem.materialItemList.length-1? '':detailItem.materialItemList[arrIndex].unitCount,//数量
                    materialItem_unitPrice: arrIndex>detailItem.materialItemList.length-1? '':detailItem.materialItemList[arrIndex].unitPrice, //单价
                    materialItem_unitSumPrice: arrIndex>detailItem.materialItemList.length-1? '':detailItem.materialItemList[arrIndex].unitSumPrice, //合价

                    otherItem_remark: arrIndex>detailItem.otherItemList.length-1? '':detailItem.otherItemList[arrIndex].remark,    //备注
                    otherItem_subCategoryName: arrIndex>detailItem.otherItemList.length-1? '':detailItem.otherItemList[arrIndex].subCategoryName,//细目名称
                    otherItem_subCategoryNo: arrIndex>detailItem.otherItemList.length-1? '':detailItem.otherItemList[arrIndex].subCategoryNo, //细目编号
                    otherItem_unit: arrIndex>detailItem.otherItemList.length-1? '':detailItem.otherItemList[arrIndex].unit,  //单位
                    otherItem_unitCount: arrIndex>detailItem.otherItemList.length-1? '':detailItem.otherItemList[arrIndex].unitCount,//数量
                    otherItem_unitPrice: arrIndex>detailItem.otherItemList.length-1? '':detailItem.otherItemList[arrIndex].unitPrice, //单价
                    otherItem_unitSumPrice: arrIndex>detailItem.otherItemList.length-1? '':detailItem.otherItemList[arrIndex].unitSumPrice, //合价

                })
            })
        }else{
            let arrIndex = 0;
            list.push({
                'index':detailIndex,
                'subIndex':arrIndex,
                'approveStatus': detailItem.approveStatus,
                'approveStatusDisplayName': detailItem.approveStatusDisplayName,
                "id": detailItem.id,
                "generalContractProjectDetailsId": detailItem.generalContractProjectDetailsId,
                "projectId": detailItem.projectId,
                "dictId": detailItem.dictId,
                "unitPrice": detailItem.unitPrice,
                "contractCount": detailItem.contractCount,
                "contractSumPrice": detailItem.contractSumPrice,
                "checkCount": detailItem.checkCount,
                "checkSumPrice": detailItem.checkSumPrice,
                "subCategoryNo": detailItem.subCategoryNo,
                "subCategoryName": detailItem.subCategoryName,
                "unit": detailItem.unit,
                "total_Price": detailItem.total_Price,
                "unit_Price": detailItem.unit_Price,

                laborItem_remark: arrIndex>detailItem.laborItemList.length-1? '':detailItem.laborItemList[arrIndex].remark,    //备注
                laborItem_subCategoryName: arrIndex>detailItem.laborItemList.length-1? '':detailItem.laborItemList[arrIndex].subCategoryName,//细目名称
                laborItem_subCategoryNo: arrIndex>detailItem.laborItemList.length-1? '':detailItem.laborItemList[arrIndex].subCategoryNo, //细目编号
                laborItem_unit: arrIndex>detailItem.laborItemList.length-1? '':detailItem.laborItemList[arrIndex].unit,  //单位
                laborItem_unitCount: arrIndex>detailItem.laborItemList.length-1? '':detailItem.laborItemList[arrIndex].unitCount,//数量
                laborItem_unitPrice: arrIndex>detailItem.laborItemList.length-1? '':detailItem.laborItemList[arrIndex].unitPrice, //单价
                laborItem_unitSumPrice: arrIndex>detailItem.laborItemList.length-1? '':detailItem.laborItemList[arrIndex].unitSumPrice, //合价

                machineItem_remark: arrIndex>detailItem.machineItemList.length-1? '':detailItem.machineItemList[arrIndex].remark,    //备注
                machineItem_subCategoryName: arrIndex>detailItem.machineItemList.length-1? '':detailItem.machineItemList[arrIndex].subCategoryName,//细目名称
                machineItem_subCategoryNo: arrIndex>detailItem.machineItemList.length-1? '':detailItem.machineItemList[arrIndex].subCategoryNo, //细目编号
                machineItem_unit: arrIndex>detailItem.machineItemList.length-1? '':detailItem.machineItemList[arrIndex].unit,  //单位
                machineItem_unitCount: arrIndex>detailItem.machineItemList.length-1? '':detailItem.machineItemList[arrIndex].unitCount,//数量
                machineItem_unitPrice: arrIndex>detailItem.machineItemList.length-1? '':detailItem.machineItemList[arrIndex].unitPrice, //单价
                machineItem_unitSumPrice: arrIndex>detailItem.machineItemList.length-1? '':detailItem.machineItemList[arrIndex].unitSumPrice, //合价

                materialItem_remark: arrIndex>detailItem.materialItemList.length-1? '':detailItem.materialItemList[arrIndex].remark,    //备注
                materialItem_productName: arrIndex>detailItem.materialItemList.length-1? '':detailItem.materialItemList[arrIndex].productName,// 存货名称
                materialItem_productNumber: arrIndex>detailItem.materialItemList.length-1? '':detailItem.materialItemList[arrIndex].productNumber, //存货编码
                materialItem_model: arrIndex>detailItem.materialItemList.length-1? '':detailItem.materialItemList[arrIndex].model, //规格型号
                materialItem_unit: arrIndex>detailItem.materialItemList.length-1? '':detailItem.materialItemList[arrIndex].unit,  //单位
                materialItem_unitCount: arrIndex>detailItem.materialItemList.length-1? '':detailItem.materialItemList[arrIndex].unitCount,//数量
                materialItem_unitPrice: arrIndex>detailItem.materialItemList.length-1? '':detailItem.materialItemList[arrIndex].unitPrice, //单价
                materialItem_unitSumPrice: arrIndex>detailItem.materialItemList.length-1? '':detailItem.materialItemList[arrIndex].unitSumPrice, //合价

                otherItem_remark: arrIndex>detailItem.otherItemList.length-1? '':detailItem.otherItemList[arrIndex].remark,    //备注
                otherItem_subCategoryName: arrIndex>detailItem.otherItemList.length-1? '':detailItem.otherItemList[arrIndex].subCategoryName,//细目名称
                otherItem_subCategoryNo: arrIndex>detailItem.otherItemList.length-1? '':detailItem.otherItemList[arrIndex].subCategoryNo, //细目编号
                otherItem_unit: arrIndex>detailItem.otherItemList.length-1? '':detailItem.otherItemList[arrIndex].unit,  //单位
                otherItem_unitCount: arrIndex>detailItem.otherItemList.length-1? '':detailItem.otherItemList[arrIndex].unitCount,//数量
                otherItem_unitPrice: arrIndex>detailItem.otherItemList.length-1? '':detailItem.otherItemList[arrIndex].unitPrice, //单价
                otherItem_unitSumPrice: arrIndex>detailItem.otherItemList.length-1? '':detailItem.otherItemList[arrIndex].unitSumPrice, //合价

            })
        }

    })
    return list;
}
//数据处理--事中
export function inTheSpanMethod(detail) {
    let list = [];
    let maxHeight = 0
    let lengthNum = 0 //循环的次数


    detail.map((detailItem,detailIndex)=> {
        // 计算预计 合计and单价
        let totalPrice = 0;
        let totalCount = 0
        let bidSumPrice = 0
        detailItem.laborExpectList.map(item => {
            totalCount+= Number(item.unitCount)
            totalPrice+= Number(item.unitSumPrice)
            bidSumPrice+= Number(item.bidSumPrice)
        })
        detailItem.machineExpectList.map(item => {
            totalCount+= Number(item.unitCount)
            totalPrice+= Number(item.unitSumPrice)
            bidSumPrice+= Number(item.bidSumPrice)
        })
        detailItem.materialExpectList.map(item => {
            totalCount+= Number(item.unitCount)
            totalPrice+= Number(item.unitSumPrice)
            bidSumPrice+= Number(item.bidSumPrice)
        })
        detailItem.otherExpectList.map(item => {
            totalCount+= Number(item.unitCount)
            totalPrice+= Number(item.unitSumPrice)
            bidSumPrice+= Number(item.bidSumPrice)
        })
        detailItem.total_Price = totalPrice == 0?0: (totalPrice).toFixed(2) //合计-合计
        detailItem.unit_Price =  totalPrice == 0?0:(totalPrice/totalCount).toFixed(2)//合计-单价
        detailItem.bidSum_Price = bidSumPrice == 0?0: (bidSumPrice).toFixed(2) //合计-中标裸税合计

        //  // 计算实际 合计and单价  totalBidSumPrice
        // let totalUnitSumPrice = 0;
        // let totalActCount = 0
        // let totalBidSumPrice = 0
        // detailItem.laborActList.map(item => {
        //     totalActCount+= Number(item.unitCount)
        //     totalUnitSumPrice+= Number(item.unitSumPrice)
        //     totalBidSumPrice+= Number(item.bidSumPrice)
        // })
        // detailItem.machineActList.map(item => {
        //     totalActCount+= Number(item.unitCount)
        //     totalUnitSumPrice+= Number(item.unitSumPrice)
        //     totalBidSumPrice+= Number(item.bidSumPrice)
        // })
        // detailItem.materialActList.map(item => {
        //     totalActCount+= Number(item.unitCount)
        //     totalUnitSumPrice+= Number(item.unitSumPrice)
        //     totalBidSumPrice+= Number(item.bidSumPrice)
        // })
        // detailItem.otherExpectList.map(item => {
        //     totalActCount+= Number(item.unitCount)
        //     totalUnitSumPrice+= Number(item.unitSumPrice)
        //     totalBidSumPrice+= Number(item.bidSumPrice)
        // })
        // detailItem.totalUnitSumPrice = totalUnitSumPrice == 0?0: (totalUnitSumPrice).toFixed(2) //合计-合计
        // detailItem.totalUnitPrice =  totalUnitSumPrice == 0||detailItem.actFinishCount==0?0:(totalUnitSumPrice/detailItem.actFinishCount).toFixed(2)//合计-单价
        // detailItem.totalBidSumPrice = bidSumPrice == 0?0: (totalBidSumPrice).toFixed(2) //合计-中标裸税合计
    
        // 比较数据的长度取最大值
        let arr = [];
        arr.push(detailItem.laborExpectList.length)
        arr.push(detailItem.machineExpectList.length)
        arr.push(detailItem.materialExpectList.length)
        arr.push(detailItem.otherExpectList.length)

        maxHeight = maxHeight+ Math.max(...arr) // 预计支付数组最大值

        let num = 0;    // 每个合作商细目条数总和
        detailItem.partyActList.map(item => {
            let obj = {
                laborActList: item.laborActList,
                machineActList: item.machineActList,
                materialActList: item.materialActList,
                otherActList: item.otherActList,
            }
            let objIndex = '';
            for (let x in obj){
                if (objIndex == '' || obj[x].length > obj[objIndex].length){
                    objIndex = x;
                }
            }
            num += item[objIndex].length
        })
        arr.push(num)
        let maxNum = Math.max(...arr)
        console.log('+++++', maxNum,maxHeight, num)

        //添加预计成本信息
        if(maxNum>0){
            for(let arrIndex = 0; arrIndex<maxNum; arrIndex++){
                list.push({
                    'index':detailIndex,
                    'subIndex':arrIndex,
                    'approveStatus': detailItem.approveStatus,
                    'approveStatusDisplayName': detailItem.approveStatusDisplayName,
                    "id": detailItem.id,
                    "generalContractProjectDetailsId": detailItem.generalContractProjectDetailsId,
                    "projectId": detailItem.projectId,
                    "dictId": detailItem.dictId,
                    "unitPrice": detailItem.unitPrice,
                    "unitPriceType": detailItem.unitPriceType,
                    "unitPriceTypeBool": detailItem.unitPriceType=='OFFICIAL'? true: false,
                    "contractCount": detailItem.contractCount,
                    "contractSumPrice": detailItem.contractSumPrice,
                    "checkCount": detailItem.checkCount,
                    "checkSumPrice": detailItem.checkSumPrice,
                    "subCategoryNo": detailItem.subCategoryNo,
                    "subCategoryName": detailItem.subCategoryName,
                    "approveStatusShow": detailItem.approveStatusShow,

                    "expectCount": detailItem.expectCount,
                    "expectSumPrice": detailItem.expectSumPrice,
                    "actFinishCount": detailItem.actFinishCount,
                    "actFinishSumPrice": detailItem.actFinishSumPrice,
                    "expectFinishCount": detailItem.expectFinishCount,
                    "expectFinishSumPrice": detailItem.expectFinishSumPrice,

                    "total_Price": detailItem.total_Price,
                    "unit_Price": detailItem.unit_Price,
                    "bidSum_Price": detailItem.bidSum_Price,

                    "totalUnitSumPrice": detailItem.totalUnitSumPrice,
                    "totalUnitPrice": detailItem.totalUnitPrice,
                    "totalBidSumPrice": detailItem.totalBidSumPrice,

                    "unit": detailItem.unit,


                    laborItem_remark: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].remark,    //备注
                    laborItem_subCategoryName: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].subCategoryName,//细目名称
                    laborItem_subCategoryNo: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].subCategoryNo, //细目编号
                    laborItem_unit: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].unit,  //单位
                    laborItem_unitCount: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].unitCount,//数量
                    laborItem_unitPrice: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].unitPrice, //单价
                    laborItem_unitSumPrice: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].unitSumPrice, //合价
                    laborItem_bidPrice: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].bidPrice, //中标裸税单价
                    laborItem_bidSumPrice: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].bidSumPrice, //中标裸税合价
                    laborItem_taxRate: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].taxRate, //税率
                    laborItem_unitPriceType: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].unitPriceType, //正式单价
                    laborItem_unitPriceTypeBool: arrIndex>detailItem.laborExpectList.length-1? false:detailItem.laborExpectList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                    machineItem_remark: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].remark,    //备注
                    machineItem_subCategoryName: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].subCategoryName,//细目名称
                    machineItem_subCategoryNo: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].subCategoryNo, //细目编号
                    machineItem_unit: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].unit,  //单位
                    machineItem_unitCount: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].unitCount,//数量
                    machineItem_unitPrice: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].unitPrice, //单价
                    machineItem_unitSumPrice: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].unitSumPrice, //合价
                    machineItem_bidPrice: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].bidPrice, //中标裸税单价
                    machineItem_bidSumPrice: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].bidSumPrice, //中标裸税合价
                    machineItem_taxRate: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].taxRate, //税率
                    machineItem_unitPriceType: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].unitPriceType, //正式单价
                    machineItem_unitPriceTypeBool: arrIndex>detailItem.machineExpectList.length-1? false:detailItem.machineExpectList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                    materialItem_remark: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].remark,    //备注
                    materialItem_productName: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].productName,// 存货名称
                    materialItem_productNumber: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].productNumber, //存货编码
                    materialItem_model: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].model, //规格型号
                    materialItem_unit: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].unit,  //单位
                    materialItem_unitCount: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].unitCount,//数量
                    materialItem_unitPrice: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].unitPrice, //单价
                    materialItem_unitSumPrice: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].unitSumPrice, //合价
                    materialItem_bidPrice: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].bidPrice, //中标裸税单价
                    materialItem_bidSumPrice: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].bidSumPrice, //中标裸税合价
                    materialItem_taxRate: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].taxRate, //税率
                    materialItem_unitPriceType: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].unitPriceType, //正式单价
                    materialItem_unitPriceTypeBool: arrIndex>detailItem.materialExpectList.length-1? false:detailItem.materialExpectList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                    otherItem_remark: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].remark,    //备注
                    otherItem_subCategoryName: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].subCategoryName,//细目名称
                    otherItem_subCategoryNo: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].subCategoryNo, //细目编号
                    otherItem_unit: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].unit,  //单位
                    otherItem_unitCount: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].unitCount,//数量
                    otherItem_unitPrice: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].unitPrice, //单价
                    otherItem_unitSumPrice: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].unitSumPrice, //合价
                    otherItem_bidPrice: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].bidPrice, //中标裸税单价
                    otherItem_bidSumPrice: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].bidSumPrice, //中标裸税合价
                    otherItem_taxRate: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].taxRate, //税率
                    otherItem_unitPriceType: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].unitPriceType, //正式单价
                    otherItem_unitPriceTypeBool: arrIndex>detailItem.otherExpectList.length-1? false:detailItem.otherExpectList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价
                })
            }
        }else{
            let arrIndex = 0;
            list.push({
                'index':detailIndex,
                'subIndex':arrIndex,
                'approveStatus': detailItem.approveStatus,
                'approveStatusDisplayName': detailItem.approveStatusDisplayName,
                "id": detailItem.id,
                "generalContractProjectDetailsId": detailItem.generalContractProjectDetailsId,
                "projectId": detailItem.projectId,
                "dictId": detailItem.dictId,
                "unitPrice": detailItem.unitPrice,
                "unitPriceType": detailItem.unitPriceType,
                "unitPriceTypeBool": detailItem.unitPriceType=='OFFICIAL'? true: false,
                "contractCount": detailItem.contractCount,
                "contractSumPrice": detailItem.contractSumPrice,
                "checkCount": detailItem.checkCount,
                "checkSumPrice": detailItem.checkSumPrice,
                "subCategoryNo": detailItem.subCategoryNo,
                "subCategoryName": detailItem.subCategoryName,
                "approveStatusShow": detailItem.approveStatusShow,

                "expectCount": detailItem.expectCount,
                "expectSumPrice": detailItem.expectSumPrice,
                "actFinishCount": detailItem.actFinishCount,
                "actFinishSumPrice": detailItem.actFinishSumPrice,
                "expectFinishCount": detailItem.expectFinishCount,
                "expectFinishSumPrice": detailItem.expectFinishSumPrice,

                "total_Price": detailItem.total_Price,
                "unit_Price": detailItem.unit_Price,
                "bidSum_Price": detailItem.bidSum_Price,

                "total_Price": detailItem.total_Price,
                    "totalActCount": detailItem.totalActCount,
                    "bidSum_Price": detailItem.bidSum_Price,

                "unit": detailItem.unit,


                laborItem_remark: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].remark,    //备注
                laborItem_subCategoryName: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].subCategoryName,//细目名称
                laborItem_subCategoryNo: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].subCategoryNo, //细目编号
                laborItem_unit: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].unit,  //单位
                laborItem_unitCount: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].unitCount,//数量
                laborItem_unitPrice: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].unitPrice, //单价
                laborItem_unitSumPrice: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].unitSumPrice, //合价
                laborItem_bidPrice: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].bidPrice, //中标裸税单价
                laborItem_bidSumPrice: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].bidSumPrice, //中标裸税合价
                laborItem_taxRate: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].taxRate, //税率
                laborItem_unitPriceType: arrIndex>detailItem.laborExpectList.length-1? '':detailItem.laborExpectList[arrIndex].unitPriceType, //正式单价
                laborItem_unitPriceTypeBool: arrIndex>detailItem.laborExpectList.length-1? false:detailItem.laborExpectList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                machineItem_remark: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].remark,    //备注
                machineItem_subCategoryName: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].subCategoryName,//细目名称
                machineItem_subCategoryNo: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].subCategoryNo, //细目编号
                machineItem_unit: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].unit,  //单位
                machineItem_unitCount: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].unitCount,//数量
                machineItem_unitPrice: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].unitPrice, //单价
                machineItem_unitSumPrice: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].unitSumPrice, //合价
                machineItem_bidPrice: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].bidPrice, //中标裸税单价
                machineItem_bidSumPrice: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].bidSumPrice, //中标裸税合价
                machineItem_taxRate: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].taxRate, //税率
                machineItem_unitPriceType: arrIndex>detailItem.machineExpectList.length-1? '':detailItem.machineExpectList[arrIndex].unitPriceType, //正式单价
                machineItem_unitPriceTypeBool: arrIndex>detailItem.machineExpectList.length-1? false:detailItem.machineExpectList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                materialItem_remark: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].remark,    //备注
                materialItem_productName: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].productName,// 存货名称
                materialItem_productNumber: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].productNumber, //存货编码
                materialItem_model: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].model, //规格型号
                materialItem_unit: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].unit,  //单位
                materialItem_unitCount: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].unitCount,//数量
                materialItem_unitPrice: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].unitPrice, //单价
                materialItem_unitSumPrice: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].unitSumPrice, //合价
                materialItem_bidPrice: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].bidPrice, //中标裸税单价
                materialItem_bidSumPrice: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].bidSumPrice, //中标裸税合价
                materialItem_taxRate: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].taxRate, //税率
                materialItem_unitPriceType: arrIndex>detailItem.materialExpectList.length-1? '':detailItem.materialExpectList[arrIndex].unitPriceType, //正式单价
                materialItem_unitPriceTypeBool: arrIndex>detailItem.materialExpectList.length-1? false:detailItem.materialExpectList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                otherItem_remark: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].remark,    //备注
                otherItem_subCategoryName: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].subCategoryName,//细目名称
                otherItem_subCategoryNo: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].subCategoryNo, //细目编号
                otherItem_unit: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].unit,  //单位
                otherItem_unitCount: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].unitCount,//数量
                otherItem_unitPrice: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].unitPrice, //单价
                otherItem_unitSumPrice: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].unitSumPrice, //合价
                otherItem_bidPrice: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].bidPrice, //中标裸税单价
                otherItem_bidSumPrice: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].bidSumPrice, //中标裸税合价
                otherItem_taxRate: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].taxRate, //税率
                otherItem_unitPriceType: arrIndex>detailItem.otherExpectList.length-1? '':detailItem.otherExpectList[arrIndex].unitPriceType, //正式单价
                otherItem_unitPriceTypeBool: arrIndex>detailItem.otherExpectList.length-1? false:detailItem.otherExpectList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价
            })
        }
        let partyPrice = 0 //实际合计-合计
        if(detailItem.partyActList.length == 0){
            list[lengthNum] = {
                ...list[lengthNum],
                nowPartyIndex: 0,
                nowArrIndex: 0,

                partyBId: '',
                partyBName: '',

                // party_unitPrice: '',
                // party_unitSumPrice: '',
                // party_bidSumPrice: '',

                nowLaborItem_remark: '',    //备注
                nowLaborItem_subCategoryName: '',//细目名称
                nowLaborItem_subCategoryNo: '', //细目编号
                nowLaborItem_unit: '',  //单位
                nowLaborItem_unitCount: '',//数量
                nowLaborItem_unitPrice: '', //单价
                nowLaborItem_unitSumPrice: '', //合价
                nowLaborItem_bidPrice: '', //中标裸税单价
                nowLaborItem_bidSumPrice: '', //中标裸税合价
                nowLaborItem_taxRate: '', //税率
                nowLaborItem_unitPriceType: '', //正式单价
                nowLaborItem_unitPriceTypeBool: '', //是否是正式单价

                nowMachineItem_remark: '',    //备注
                nowMachineItem_subCategoryName: '',//细目名称
                nowMachineItem_subCategoryNo: '', //细目编号
                nowMachineItem_unit: '',  //单位
                nowMachineItem_unitCount: '',//数量
                nowMachineItem_unitPrice: '', //单价
                nowMachineItem_unitSumPrice: '', //合价
                nowMachineItem_bidPrice: '', //中标裸税单价
                nowMachineItem_bidSumPrice: '', //中标裸税合价
                nowMachineItem_taxRate: '', //税率
                nowMachineItem_unitPriceType: '', //正式单价
                nowMachineItem_unitPriceTypeBool: '', //是否是正式单价

                nowMaterialItem_remark: '',    //备注
                nowMaterialItem_productName: '',// 存货名称
                nowMaterialItem_productNumber: '', //存货编码
                nowMaterialItem_model: '', //规格型号
                nowMaterialItem_unit: '',  //单位
                nowMaterialItem_unitCount: '',//数量
                nowMaterialItem_unitPrice: '', //单价
                nowMaterialItem_unitSumPrice: '', //合价
                nowMaterialItem_bidPrice: '', //中标裸税单价
                nowMaterialItem_bidSumPrice: '', //中标裸税合价
                nowMaterialItem_taxRate: '', //税率
                nowMaterialItem_unitPriceType: '', //正式单价
                nowMaterialItem_unitPriceTypeBool: '', //是否是正式单价

                nowOtherItem_remark: '',    //备注
                nowOtherItem_subCategoryName: '',//细目名称
                nowOtherItem_subCategoryNo: '', //细目编号
                nowOtherItem_unit: '',  //单位
                nowOtherItem_unitCount: '',//数量
                nowOtherItem_unitPrice: '', //单价
                nowOtherItem_unitSumPrice: '', //合价
                nowOtherItem_bidPrice: '', //中标裸税单价
                nowOtherItem_bidSumPrice: '', //中标裸税合价
                nowOtherItem_taxRate: '', //税率
                nowOtherItem_unitPriceType: '', //正式单价
                nowOtherItem_unitPriceTypeBool: '', //是否是正式单价
            }
            lengthNum += 1
        }else{
            //添加实际成本信息
            detailItem.partyActList.map((item,partyActIndex) => {
                let obj = {
                    laborActList: item.laborActList,
                    machineActList: item.machineActList,
                    materialActList: item.materialActList,
                    otherActList: item.otherActList,
                }
                let objIndex = '';
                for (let x in obj){
                    if (objIndex == '' || obj[x].length > obj[objIndex].length){
                        objIndex = x;
                    }
                }
                item[objIndex].map((arr1Item,arrIndex)=> {
                    list[lengthNum] = {
                        ...list[lengthNum],
                        nowPartyIndex: partyActIndex,
                        nowArrIndex: arrIndex,

                        partyBId: item.partyBId,
                        partyBName: item.partyBName,

                        // party_unitPrice: Number(item.unitSumPrice) == 0? '':(Number(item.unitSumPrice)/item.unitCount).toFixed(2),
                        // party_unitSumPrice: Number(item.unitSumPrice)==0? 0: Number(item.unitSumPrice).toFixed(2),
                        // party_bidSumPrice: Number(item.bidSumPrice)==0? 0: Number(item.bidSumPrice).toFixed(2),

                        nowLaborItem_remark: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].remark,    //备注
                        nowLaborItem_subCategoryName: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].subCategoryName,//细目名称
                        nowLaborItem_subCategoryNo: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].subCategoryNo, //细目编号
                        nowLaborItem_unit: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].unit,  //单位
                        nowLaborItem_unitCount: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].unitCount,//数量
                        nowLaborItem_unitPrice: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].unitPrice, //单价
                        nowLaborItem_unitSumPrice: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].unitSumPrice, //合价
                        nowLaborItem_bidPrice: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].bidPrice, //中标裸税单价
                        nowLaborItem_bidSumPrice: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].bidSumPrice, //中标裸税合价
                        nowLaborItem_taxRate: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].taxRate, //税率
                        nowLaborItem_unitPriceType: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].unitPriceType, //正式单价
                        nowLaborItem_unitPriceTypeBool: arrIndex>item.laborActList.length-1? false:item.laborActList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                        nowMachineItem_remark: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].remark,    //备注
                        nowMachineItem_subCategoryName: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].subCategoryName,//细目名称
                        nowMachineItem_subCategoryNo: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].subCategoryNo, //细目编号
                        nowMachineItem_unit: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].unit,  //单位
                        nowMachineItem_unitCount: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].unitCount,//数量
                        nowMachineItem_unitPrice: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].unitPrice, //单价
                        nowMachineItem_unitSumPrice: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].unitSumPrice, //合价
                        nowMachineItem_bidPrice: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].bidPrice, //中标裸税单价
                        nowMachineItem_bidSumPrice: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].bidSumPrice, //中标裸税合价
                        nowMachineItem_taxRate: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].taxRate, //税率
                        nowMachineItem_unitPriceType: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].unitPriceType, //正式单价
                        nowMachineItem_unitPriceTypeBool: arrIndex>item.machineActList.length-1? false:item.machineActList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                        nowMaterialItem_remark: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].remark,    //备注
                        nowMaterialItem_productName: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].productName,// 存货名称
                        nowMaterialItem_productNumber: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].productNumber, //存货编码
                        nowMaterialItem_model: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].model, //规格型号
                        nowMaterialItem_unit: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].unit,  //单位
                        nowMaterialItem_unitCount: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].unitCount,//数量
                        nowMaterialItem_unitPrice: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].unitPrice, //单价
                        nowMaterialItem_unitSumPrice: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].unitSumPrice, //合价
                        nowMaterialItem_bidPrice: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].bidPrice, //中标裸税单价
                        nowMaterialItem_bidSumPrice: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].bidSumPrice, //中标裸税合价
                        nowMaterialItem_taxRate: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].taxRate, //税率
                        nowMaterialItem_unitPriceType: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].unitPriceType, //正式单价
                        nowMaterialItem_unitPriceTypeBool: arrIndex>item.materialActList.length-1? false:item.materialActList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                        nowOtherItem_remark: arrIndex>item.otherActList.length-1? '':item.otherActList[arrIndex].remark,    //备注
                        nowOtherItem_subCategoryName: arrIndex>item.otherActList.length-1? '':item.otherActList[arrIndex].subCategoryName,//细目名称
                        nowOtherItem_subCategoryNo: arrIndex>item.otherActList.length-1? '':item.otherActList[arrIndex].subCategoryNo, //细目编号
                        nowOtherItem_unit: arrIndex>item.otherActList.length-1? '':item.otherActList[arrIndex].unit,  //单位
                        nowOtherItem_unitCount: arrIndex>item.otherActList.length-1? '':item.otherActList[arrIndex].unitCount,//数量
                        nowOtherItem_unitPrice: arrIndex>item.otherActList.length-1? '':item.otherActList[arrIndex].unitPrice, //单价
                        nowOtherItem_unitSumPrice: arrIndex>item.otherActList.length-1? '':item.otherActList[arrIndex].unitSumPrice, //合价
                        nowOtherItem_bidPrice: arrIndex>item.otherActList.length-1? '':item.otherActList[arrIndex].bidPrice, //中标裸税单价
                        nowOtherItem_bidSumPrice: arrIndex>item.otherActList.length-1? '':item.otherActList[arrIndex].bidSumPrice, //中标裸税合价
                        nowOtherItem_taxRate: arrIndex>item.otherActList.length-1? '':item.otherActList[arrIndex].taxRate, //税率
                        nowOtherItem_unitPriceType: arrIndex>item.otherActList.length-1? '':item.otherActList[arrIndex].unitPriceType, //正式单价
                        nowOtherItem_unitPriceTypeBool: arrIndex>item.otherActList.length-1? false:item.otherActList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价
                    }
                    lengthNum += 1
                })
            })
        }
        console.log(list.length, lengthNum)
        if(list.length > lengthNum){
            let cishu = list.length - lengthNum
            for (let arrIndex = 0; arrIndex< cishu; arrIndex++){
                list[lengthNum] = {
                    ...list[lengthNum],

                    partyBId: '',
                    partyBName: '',

                    // party_unitPrice: '',
                    // party_unitSumPrice: '',
                    // party_bidSumPrice: '',

                    nowLaborItem_remark: '',    //备注
                    nowLaborItem_subCategoryName: '',//细目名称
                    nowLaborItem_subCategoryNo: '', //细目编号
                    nowLaborItem_unit: '',  //单位
                    nowLaborItem_unitCount: '',//数量
                    nowLaborItem_unitPrice: '', //单价
                    nowLaborItem_unitSumPrice: '', //合价
                    nowLaborItem_bidPrice: '', //中标裸税单价
                    nowLaborItem_bidSumPrice: '', //中标裸税合价
                    nowLaborItem_taxRate: '', //税率
                    nowLaborItem_unitPriceType: '', //正式单价
                    nowLaborItem_unitPriceTypeBool: '', //是否是正式单价

                    nowMachineItem_remark: '',    //备注
                    nowMachineItem_subCategoryName: '',//细目名称
                    nowMachineItem_subCategoryNo: '', //细目编号
                    nowMachineItem_unit: '',  //单位
                    nowMachineItem_unitCount: '',//数量
                    nowMachineItem_unitPrice: '', //单价
                    nowMachineItem_unitSumPrice: '', //合价
                    nowMachineItem_bidPrice: '', //中标裸税单价
                    nowMachineItem_bidSumPrice: '', //中标裸税合价
                    nowMachineItem_taxRate: '', //税率
                    nowMachineItem_unitPriceType: '', //正式单价
                    nowMachineItem_unitPriceTypeBool: '', //是否是正式单价

                    nowMaterialItem_remark: '',    //备注
                    nowMaterialItem_productName: '',// 存货名称
                    nowMaterialItem_productNumber: '', //存货编码
                    nowMaterialItem_model: '', //规格型号
                    nowMaterialItem_unit: '',  //单位
                    nowMaterialItem_unitCount: '',//数量
                    nowMaterialItem_unitPrice: '', //单价
                    nowMaterialItem_unitSumPrice: '', //合价
                    nowMaterialItem_bidPrice: '', //中标裸税单价
                    nowMaterialItem_bidSumPrice: '', //中标裸税合价
                    nowMaterialItem_taxRate: '', //税率
                    nowMaterialItem_unitPriceType: '', //正式单价
                    nowMaterialItem_unitPriceTypeBool: '', //是否是正式单价

                    nowOtherItem_remark: '',    //备注
                    nowOtherItem_subCategoryName: '',//细目名称
                    nowOtherItem_subCategoryNo: '', //细目编号
                    nowOtherItem_unit: '',  //单位
                    nowOtherItem_unitCount: '',//数量
                    nowOtherItem_unitPrice: '', //单价
                    nowOtherItem_unitSumPrice: '', //合价
                    nowOtherItem_bidPrice: '', //中标裸税单价
                    nowOtherItem_bidSumPrice: '', //中标裸税合价
                    nowOtherItem_taxRate: '', //税率
                    nowOtherItem_unitPriceType: '', //正式单价
                    nowOtherItem_unitPriceTypeBool: '', //是否是正式单价
                }
                lengthNum += 1
            }
        }
    })
    console.log(list)
    return list;
}

//数据处理--其它直接费
export function otherDirectMethod(detail) {
    let list = [];
    let maxHeight = 0
    let lengthNum = 0 //循环的次数
    detail.map((detailItem,detailIndex)=> {
        // 比较数据的长度取最大值
        let arr = [];
        let num = 0;    // 每个合作商细目条数总和
        detailItem.partyActList.map(item => {
            let obj = {
                laborActList: item.laborActList,
                machineActList: item.machineActList,
                materialActList: item.materialActList,
                // otherActList: item.otherActList,
            }
            let objIndex = '';
            for (let x in obj){
                if (objIndex == '' || obj[x].length > obj[objIndex].length){
                    objIndex = x;
                }
            }
            num += item[objIndex].length
        })
        arr.push(num)
        let maxNum = Math.max(...arr)
        //添加细目信息
        if(maxNum>0){
            for(let arrIndex = 0; arrIndex<maxNum; arrIndex++){
                list.push({
                    'index':detailIndex,
                    'subIndex':arrIndex,
                    "id": detailItem.id,
                    "generalContractProjectDetailsId": detailItem.generalContractProjectDetailsId,
                    "projectId": detailItem.projectId,
                    "dictId": detailItem.dictId,
                    "unitPrice": detailItem.unitPrice,
                    "unitPriceType": detailItem.unitPriceType,
                    "unitPriceTypeBool": detailItem.unitPriceType=='OFFICIAL'? true: false,
                    "contractCount": detailItem.contractCount,
                    "contractSumPrice": detailItem.contractSumPrice,
                    "checkCount": detailItem.checkCount,
                    "checkSumPrice": detailItem.checkSumPrice,
                    "subCategoryNo": detailItem.subCategoryNo,
                    "subCategoryName": detailItem.subCategoryName,

                    "expectCount": detailItem.expectCount,
                    "expectSumPrice": detailItem.expectSumPrice,
                    "actFinishCount": detailItem.actFinishCount,
                    "actFinishSumPrice": detailItem.actFinishSumPrice,
                    "expectFinishCount": detailItem.expectFinishCount,
                    "expectFinishSumPrice": detailItem.expectFinishSumPrice,

                    // "total_Price": detailItem.total_Price,
                    // "unit_Price": detailItem.unit_Price,
                    // "bidSum_Price": detailItem.bidSum_Price,

                    "unit": detailItem.unit,

                })
            }
        }else{
            let arrIndex = 0;
            list.push({
                'index':detailIndex,
                'subIndex':arrIndex,
                'approveStatus': detailItem.approveStatus,
                'approveStatusDisplayName': detailItem.approveStatusDisplayName,
                "id": detailItem.id,
                "generalContractProjectDetailsId": detailItem.generalContractProjectDetailsId,
                "projectId": detailItem.projectId,
                "dictId": detailItem.dictId,
                "unitPrice": detailItem.unitPrice,
                "unitPriceType": detailItem.unitPriceType,
                "unitPriceTypeBool": detailItem.unitPriceType=='OFFICIAL'? true: false,
                "contractCount": detailItem.contractCount,
                "contractSumPrice": detailItem.contractSumPrice,
                "checkCount": detailItem.checkCount,
                "checkSumPrice": detailItem.checkSumPrice,
                "subCategoryNo": detailItem.subCategoryNo,
                "subCategoryName": detailItem.subCategoryName,

                "expectCount": detailItem.expectCount,
                "expectSumPrice": detailItem.expectSumPrice,
                "actFinishCount": detailItem.actFinishCount,
                "actFinishSumPrice": detailItem.actFinishSumPrice,
                "expectFinishCount": detailItem.expectFinishCount,
                "expectFinishSumPrice": detailItem.expectFinishSumPrice,


                // "total_Price": detailItem.total_Price,
                // "unit_Price": detailItem.unit_Price,
                // "bidSum_Price": detailItem.bidSum_Price,

                "unit": detailItem.unit,


              
            })
        }
        let partyPrice = 0 //实际合计-合计
        if(detailItem.partyActList.length == 0){
            list[lengthNum] = {
                ...list[lengthNum],
                partyIndex: 0,
                arrIndex: 0,
                partyBId: '',
                partyBName: '',
                laborItem_remark: '',    //备注
                laborItem_subCategoryName: '',//细目名称
                laborItem_subCategoryNo: '', //细目编号
                laborItem_unit: '',  //单位
                laborItem_unitCount: '',//数量
                laborItem_unitPrice: '', //单价
                laborItem_unitSumPrice: '', //合价
                laborItem_bidPrice: '', //中标裸税单价
                laborItem_bidSumPrice: '', //中标裸税合价
                laborItem_taxRate: '', //税率
                laborItem_unitPriceType: '', //正式单价
                laborItem_unitPriceTypeBool: '', //是否是正式单价

                 machineItem_remark: '',    //备注
                machineItem_subCategoryName: '',//细目名称
                machineItem_subCategoryNo: '', //细目编号
                machineItem_unit: '',  //单位
                machineItem_unitCount: '',//数量
                machineItem_unitPrice: '', //单价
                machineItem_unitSumPrice: '', //合价
                machineItem_bidPrice: '', //中标裸税单价
                machineItem_bidSumPrice: '', //中标裸税合价
                machineItem_taxRate: '', //税率
                machineItem_unitPriceType: '', //正式单价
                machineItem_unitPriceTypeBool: '', //是否是正式单价

                materialItem_remark: '',    //备注
                materialItem_productName: '',// 存货名称
                materialItem_productNumber: '', //存货编码
                materialItem_model: '', //规格型号
                materialItem_unit: '',  //单位
                materialItem_unitCount: '',//数量
                materialItem_unitPrice: '', //单价
                materialItem_unitSumPrice: '', //合价
                materialItem_bidPrice: '', //中标裸税单价
                materialItem_bidSumPrice: '', //中标裸税合价
                materialItem_taxRate: '', //税率
                materialItem_unitPriceType: '', //正式单价
                materialItem_unitPriceTypeBool: '', //是否是正式单价

            }
            lengthNum += 1
        }else{
            //添加实际成本信息
            detailItem.partyActList.map((item,partyActIndex) => {
                let obj = {
                    laborActList: item.laborActList,
                    machineActList: item.machineActList,
                    materialActList: item.materialActList,
                    // otherActList: item.otherActList,
                }
                let objIndex = '';
                for (let x in obj){
                    if (objIndex == '' || obj[x].length > obj[objIndex].length){
                        objIndex = x;
                    }
                }
                item[objIndex].map((arr1Item,arrIndex)=> {
                    list[lengthNum] = {
                        ...list[lengthNum],
                        partyIndex: partyActIndex,
                        arrIndex: arrIndex,

                        partyBId: item.partyBId,
                        partyBName: item.partyBName,

                        // party_unitPrice: Number(item.unitSumPrice) == 0? '':(Number(item.unitSumPrice)/item.unitCount).toFixed(2),
                        // party_unitSumPrice: Number(item.unitSumPrice)==0? 0: Number(item.unitSumPrice).toFixed(2),
                        // party_bidSumPrice: Number(item.bidSumPrice)==0? 0: Number(item.bidSumPrice).toFixed(2),

                        laborItem_remark: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].remark,    //备注
                        laborItem_subCategoryName: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].subCategoryName,//细目名称
                        laborItem_subCategoryNo: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].subCategoryNo, //细目编号
                        laborItem_unit: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].unit,  //单位
                        laborItem_unitCount: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].unitCount,//数量
                        laborItem_unitPrice: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].unitPrice, //单价
                        laborItem_unitSumPrice: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].unitSumPrice, //合价
                        laborItem_bidPrice: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].bidPrice, //中标裸税单价
                        laborItem_bidSumPrice: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].bidSumPrice, //中标裸税合价
                        laborItem_taxRate: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].taxRate, //税率
                        laborItem_unitPriceType: arrIndex>item.laborActList.length-1? '':item.laborActList[arrIndex].unitPriceType, //正式单价
                        laborItem_unitPriceTypeBool: arrIndex>item.laborActList.length-1? false:item.laborActList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                        machineItem_remark: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].remark,    //备注
                        machineItem_subCategoryName: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].subCategoryName,//细目名称
                        machineItem_subCategoryNo: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].subCategoryNo, //细目编号
                        machineItem_unit: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].unit,  //单位
                        machineItem_unitCount: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].unitCount,//数量
                        machineItem_unitPrice: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].unitPrice, //单价
                        machineItem_unitSumPrice: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].unitSumPrice, //合价
                        machineItem_bidPrice: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].bidPrice, //中标裸税单价
                        machineItem_bidSumPrice: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].bidSumPrice, //中标裸税合价
                        machineItem_taxRate: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].taxRate, //税率
                        machineItem_unitPriceType: arrIndex>item.machineActList.length-1? '':item.machineActList[arrIndex].unitPriceType, //正式单价
                        machineItem_unitPriceTypeBool: arrIndex>item.machineActList.length-1? false:item.machineActList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                       materialItem_remark: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].remark,    //备注
                       materialItem_productName: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].productName,// 存货名称
                       materialItem_productNumber: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].productNumber, //存货编码
                       materialItem_model: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].model, //规格型号
                       materialItem_unit: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].unit,  //单位
                       materialItem_unitCount: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].unitCount,//数量
                       materialItem_unitPrice: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].unitPrice, //单价
                       materialItem_unitSumPrice: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].unitSumPrice, //合价
                       materialItem_bidPrice: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].bidPrice, //中标裸税单价
                       materialItem_bidSumPrice: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].bidSumPrice, //中标裸税合价
                       materialItem_taxRate: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].taxRate, //税率
                       materialItem_unitPriceType: arrIndex>item.materialActList.length-1? '':item.materialActList[arrIndex].unitPriceType, //正式单价
                       materialItem_unitPriceTypeBool: arrIndex>item.materialActList.length-1? false:item.materialActList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                     }
                    lengthNum += 1
                })
            })
        }
        console.log(list.length, lengthNum)
        if(list.length > lengthNum){
            let cishu = list.length - lengthNum
            for (let arrIndex = 0; arrIndex< cishu; arrIndex++){
                list[lengthNum] = {
                    ...list[lengthNum],

                    partyBId: '',
                    partyBName: '',

                    unitPrice: '',
                    unitSumPrice: '',
                    bidSumPrice: '',

                    laborItem_remark: '',    //备注
                    laborItem_subCategoryName: '',//细目名称
                    laborItem_subCategoryNo: '', //细目编号
                    laborItem_unit: '',  //单位
                    laborItem_unitCount: '',//数量
                    laborItem_unitPrice: '', //单价
                    laborItem_unitSumPrice: '', //合价
                    laborItem_bidPrice: '', //中标裸税单价
                    laborItem_bidSumPrice: '', //中标裸税合价
                    laborItem_taxRate: '', //税率
                    laborItem_unitPriceType: '', //正式单价
                    laborItem_unitPriceTypeBool: '', //是否是正式单价

                    machineItem_remark: '',    //备注
                    machineItem_subCategoryName: '',//细目名称
                    machineItem_subCategoryNo: '', //细目编号
                    machineItem_unit: '',  //单位
                    machineItem_unitCount: '',//数量
                    machineItem_unitPrice: '', //单价
                    machineItem_unitSumPrice: '', //合价
                    machineItem_bidPrice: '', //中标裸税单价
                    machineItem_bidSumPrice: '', //中标裸税合价
                    machineItem_taxRate: '', //税率
                    machineItem_unitPriceType: '', //正式单价
                    machineItem_unitPriceTypeBool: '', //是否是正式单价

                   materialItem_remark: '',    //备注
                   materialItem_productName: '',// 存货名称
                   materialItem_productNumber: '', //存货编码
                   materialItem_model: '', //规格型号
                   materialItem_unit: '',  //单位
                   materialItem_unitCount: '',//数量
                   materialItem_unitPrice: '', //单价
                   materialItem_unitSumPrice: '', //合价
                   materialItem_bidPrice: '', //中标裸税单价
                   materialItem_bidSumPrice: '', //中标裸税合价
                   materialItem_taxRate: '', //税率
                   materialItem_unitPriceType: '', //正式单价
                   materialItem_unitPriceTypeBool: '', //是否是正式单价
                }
                lengthNum += 1
            }
        }
    })
    console.log(list)
    return list;
}
//数据处理--措施费
export function measureMethod(detail) {
    let list = [];
    let maxHeight = 0
    let lengthNum = 0 //循环的次数


    detail.map((detailItem,detailIndex)=> {
        // 计算预计 合计and单价
        let totalPrice = 0;
        let totalCount = 0
        let bidSumPrice = 0
        detailItem.laborActList.map(item => {
            totalCount+= Number(item.unitCount)
            totalPrice+= Number(item.unitSumPrice)
            bidSumPrice+= Number(item.bidSumPrice)
        })
        detailItem.machineActList.map(item => {
            totalCount+= Number(item.unitCount)
            totalPrice+= Number(item.unitSumPrice)
            bidSumPrice+= Number(item.bidSumPrice)
        })
        detailItem.materialActList.map(item => {
            totalCount+= Number(item.unitCount)
            totalPrice+= Number(item.unitSumPrice)
            bidSumPrice+= Number(item.bidSumPrice)
        })
        detailItem.otherActList.map(item => {
            totalCount+= Number(item.unitCount)
            totalPrice+= Number(item.unitSumPrice)
            bidSumPrice+= Number(item.bidSumPrice)
        })
        detailItem.total_Price = totalPrice == 0?0: (totalPrice).toFixed(2) //合计-合计
        detailItem.unit_Price =  totalPrice == 0?0:(totalPrice/totalCount).toFixed(2)//合计-单价
        detailItem.bidSum_Price = bidSumPrice == 0?0: (bidSumPrice).toFixed(2) //合计-中标裸税合计
        // 比较数据的长度取最大值
        let arr = [];
        arr.push(detailItem.laborActList.length)
        arr.push(detailItem.machineActList.length)
        arr.push(detailItem.materialActList.length)
        arr.push(detailItem.otherActList.length)

        maxHeight =  Math.max(...arr) // 预计支付数组最大值

        // let num = 0;    // 每个合作商细目条数总和
        // detailItem.partyActList.map(item => {
        //     let obj = {
        //         laborActList: item.laborActList,
        //         machineActList: item.machineActList,
        //         materialActList: item.materialActList,
        //         // otherActList: item.otherActList,
        //     }
        //     let objIndex = '';
        //     for (let x in obj){
        //         if (objIndex == '' || obj[x].length > obj[objIndex].length){
        //             objIndex = x;
        //         }
        //     }
        //     num += item[objIndex].length
        // })
        // arr.push(num)
        // let maxNum = Math.max(...arr)
        // console.log('+++++', maxNum,maxHeight, num)

        //添加预计成本信息
        if(maxHeight>0){
            for(let arrIndex = 0; arrIndex<maxHeight; arrIndex++){
                list.push({
                    'index':detailIndex,
                    'subIndex':arrIndex,
                    'approveStatus': detailItem.approveStatus,
                    'approveStatusDisplayName': detailItem.approveStatusDisplayName,
                    "id": detailItem.id,
                    "generalContractProjectDetailsId": detailItem.generalContractProjectDetailsId,
                    "projectId": detailItem.projectId,
                    "dictId": detailItem.dictId,
                    "unitPrice": detailItem.unitPrice,
                    "unitPriceType": detailItem.unitPriceType,
                    "unitPriceTypeBool": detailItem.unitPriceType=='OFFICIAL'? true: false,
                    "contractCount": detailItem.contractCount,
                    "contractSumPrice": detailItem.contractSumPrice,
                    "checkCount": detailItem.checkCount,
                    "checkSumPrice": detailItem.checkSumPrice,
                    "subCategoryNo": detailItem.subCategoryNo,
                    "subCategoryName": detailItem.subCategoryName,
                    "approveStatusShow": detailItem.approveStatusShow,

                    "expectCount": detailItem.expectCount,
                    "expectSumPrice": detailItem.expectSumPrice,
                    "actFinishCount": detailItem.actFinishCount,
                    "actFinishSumPrice": detailItem.actFinishSumPrice,
                    "expectFinishCount": detailItem.expectFinishCount,
                    "expectFinishSumPrice": detailItem.expectFinishSumPrice,

                    "total_Price": detailItem.total_Price,
                    "unit_Price": detailItem.unit_Price,
                    "bidSum_Price": detailItem.bidSum_Price,

                    "unit": detailItem.unit,
                    "partyBName":detailItem.partyBName,
                    "partyBId":detailItem.partyBId,


                    laborItem_remark: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].remark,    //备注
                    laborItem_subCategoryName: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].subCategoryName,//细目名称
                    laborItem_subCategoryNo: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].subCategoryNo, //细目编号
                    laborItem_unit: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].unit,  //单位
                    laborItem_unitCount: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].unitCount,//数量
                    laborItem_unitPrice: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].unitPrice, //单价
                    laborItem_unitSumPrice: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].unitSumPrice, //合价
                    laborItem_bidPrice: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].bidPrice, //中标裸税单价
                    laborItem_bidSumPrice: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].bidSumPrice, //中标裸税合价
                    laborItem_taxRate: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].taxRate, //税率
                    laborItem_unitPriceType: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].unitPriceType, //正式单价
                    laborItem_unitPriceTypeBool: arrIndex>detailItem.laborActList.length-1? false:detailItem.laborActList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                    machineItem_remark: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].remark,    //备注
                    machineItem_subCategoryName: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].subCategoryName,//细目名称
                    machineItem_subCategoryNo: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].subCategoryNo, //细目编号
                    machineItem_unit: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].unit,  //单位
                    machineItem_unitCount: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].unitCount,//数量
                    machineItem_unitPrice: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].unitPrice, //单价
                    machineItem_unitSumPrice: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].unitSumPrice, //合价
                    machineItem_bidPrice: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].bidPrice, //中标裸税单价
                    machineItem_bidSumPrice: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].bidSumPrice, //中标裸税合价
                    machineItem_taxRate: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].taxRate, //税率
                    machineItem_unitPriceType: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].unitPriceType, //正式单价
                    machineItem_unitPriceTypeBool: arrIndex>detailItem.machineActList.length-1? false:detailItem.machineActList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                    materialItem_remark: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].remark,    //备注
                    materialItem_productName: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].productName,// 存货名称
                    materialItem_productNumber: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].productNumber, //存货编码
                    materialItem_model: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].model, //规格型号
                    materialItem_unit: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].unit,  //单位
                    materialItem_unitCount: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].unitCount,//数量
                    materialItem_unitPrice: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].unitPrice, //单价
                    materialItem_unitSumPrice: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].unitSumPrice, //合价
                    materialItem_bidPrice: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].bidPrice, //中标裸税单价
                    materialItem_bidSumPrice: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].bidSumPrice, //中标裸税合价
                    materialItem_taxRate: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].taxRate, //税率
                    materialItem_unitPriceType: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].unitPriceType, //正式单价
                    materialItem_unitPriceTypeBool: arrIndex>detailItem.materialActList.length-1? false:detailItem.materialActList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                    otherItem_remark: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].remark,    //备注
                    otherItem_subCategoryName: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].subCategoryName,//细目名称
                    otherItem_subCategoryNo: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].subCategoryNo, //细目编号
                    otherItem_unit: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].unit,  //单位
                    otherItem_unitCount: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].unitCount,//数量
                    otherItem_unitPrice: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].unitPrice, //单价
                    otherItem_unitSumPrice: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].unitSumPrice, //合价
                    otherItem_bidPrice: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].bidPrice, //中标裸税单价
                    otherItem_bidSumPrice: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].bidSumPrice, //中标裸税合价
                    otherItem_taxRate: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].taxRate, //税率
                    otherItem_unitPriceType: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].unitPriceType, //正式单价
                    otherItem_unitPriceTypeBool: arrIndex>detailItem.otherActList.length-1? false:detailItem.otherActList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价
                })
            }
        }else{
            let arrIndex = 0;
            list.push({
                'index':detailIndex,
                'subIndex':arrIndex,
                'approveStatus': detailItem.approveStatus,
                'approveStatusDisplayName': detailItem.approveStatusDisplayName,
                "id": detailItem.id,
                "generalContractProjectDetailsId": detailItem.generalContractProjectDetailsId,
                "projectId": detailItem.projectId,
                "dictId": detailItem.dictId,
                "unitPrice": detailItem.unitPrice,
                "unitPriceType": detailItem.unitPriceType,
                "unitPriceTypeBool": detailItem.unitPriceType=='OFFICIAL'? true: false,
                "contractCount": detailItem.contractCount,
                "contractSumPrice": detailItem.contractSumPrice,
                "checkCount": detailItem.checkCount,
                "checkSumPrice": detailItem.checkSumPrice,
                "subCategoryNo": detailItem.subCategoryNo,
                "subCategoryName": detailItem.subCategoryName,
                "approveStatusShow": detailItem.approveStatusShow,

                "expectCount": detailItem.expectCount,
                "expectSumPrice": detailItem.expectSumPrice,
                "actFinishCount": detailItem.actFinishCount,
                "actFinishSumPrice": detailItem.actFinishSumPrice,
                "expectFinishCount": detailItem.expectFinishCount,
                "expectFinishSumPrice": detailItem.expectFinishSumPrice,

                "total_Price": detailItem.total_Price,
                "unit_Price": detailItem.unit_Price,
                "bidSum_Price": detailItem.bidSum_Price,

                "unit": detailItem.unit,
                "partyBName":detailItem.partyBName,
                "partyBId":detailItem.partyBId,



                laborItem_remark: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].remark,    //备注
                laborItem_subCategoryName: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].subCategoryName,//细目名称
                laborItem_subCategoryNo: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].subCategoryNo, //细目编号
                laborItem_unit: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].unit,  //单位
                laborItem_unitCount: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].unitCount,//数量
                laborItem_unitPrice: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].unitPrice, //单价
                laborItem_unitSumPrice: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].unitSumPrice, //合价
                laborItem_bidPrice: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].bidPrice, //中标裸税单价
                laborItem_bidSumPrice: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].bidSumPrice, //中标裸税合价
                laborItem_taxRate: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].taxRate, //税率
                laborItem_unitPriceType: arrIndex>detailItem.laborActList.length-1? '':detailItem.laborActList[arrIndex].unitPriceType, //正式单价
                laborItem_unitPriceTypeBool: arrIndex>detailItem.laborActList.length-1? false:detailItem.laborActList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                machineItem_remark: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].remark,    //备注
                machineItem_subCategoryName: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].subCategoryName,//细目名称
                machineItem_subCategoryNo: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].subCategoryNo, //细目编号
                machineItem_unit: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].unit,  //单位
                machineItem_unitCount: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].unitCount,//数量
                machineItem_unitPrice: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].unitPrice, //单价
                machineItem_unitSumPrice: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].unitSumPrice, //合价
                machineItem_bidPrice: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].bidPrice, //中标裸税单价
                machineItem_bidSumPrice: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].bidSumPrice, //中标裸税合价
                machineItem_taxRate: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].taxRate, //税率
                machineItem_unitPriceType: arrIndex>detailItem.machineActList.length-1? '':detailItem.machineActList[arrIndex].unitPriceType, //正式单价
                machineItem_unitPriceTypeBool: arrIndex>detailItem.machineActList.length-1? false:detailItem.machineActList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                materialItem_remark: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].remark,    //备注
                materialItem_productName: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].productName,// 存货名称
                materialItem_productNumber: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].productNumber, //存货编码
                materialItem_model: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].model, //规格型号
                materialItem_unit: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].unit,  //单位
                materialItem_unitCount: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].unitCount,//数量
                materialItem_unitPrice: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].unitPrice, //单价
                materialItem_unitSumPrice: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].unitSumPrice, //合价
                materialItem_bidPrice: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].bidPrice, //中标裸税单价
                materialItem_bidSumPrice: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].bidSumPrice, //中标裸税合价
                materialItem_taxRate: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].taxRate, //税率
                materialItem_unitPriceType: arrIndex>detailItem.materialActList.length-1? '':detailItem.materialActList[arrIndex].unitPriceType, //正式单价
                materialItem_unitPriceTypeBool: arrIndex>detailItem.materialActList.length-1? false:detailItem.materialActList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价

                otherItem_remark: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].remark,    //备注
                otherItem_subCategoryName: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].subCategoryName,//细目名称
                otherItem_subCategoryNo: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].subCategoryNo, //细目编号
                otherItem_unit: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].unit,  //单位
                otherItem_unitCount: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].unitCount,//数量
                otherItem_unitPrice: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].unitPrice, //单价
                otherItem_unitSumPrice: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].unitSumPrice, //合价
                otherItem_bidPrice: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].bidPrice, //中标裸税单价
                otherItem_bidSumPrice: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].bidSumPrice, //中标裸税合价
                otherItem_taxRate: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].taxRate, //税率
                otherItem_unitPriceType: arrIndex>detailItem.otherActList.length-1? '':detailItem.otherActList[arrIndex].unitPriceType, //正式单价
                otherItem_unitPriceTypeBool: arrIndex>detailItem.otherActList.length-1? false:detailItem.otherActList[arrIndex].unitPriceType=='OFFICIAL'? true: false, //是否是正式单价
            })
        }
        console.log(list.length, lengthNum)
        // if(list.length > lengthNum){
        //     let cishu = list.length - lengthNum
        //     for (let arrIndex = 0; arrIndex< cishu; arrIndex++){
        //         list[lengthNum] = {
        //             ...list[lengthNum],

        //             partyBId: '',
        //             partyBName: '',

        //             party_unitPrice: '',
        //             party_unitSumPrice: '',
        //             party_bidSumPrice: '',

        //             nowLaborItem_remark: '',    //备注
        //             nowLaborItem_subCategoryName: '',//细目名称
        //             nowLaborItem_subCategoryNo: '', //细目编号
        //             nowLaborItem_unit: '',  //单位
        //             nowLaborItem_unitCount: '',//数量
        //             nowLaborItem_unitPrice: '', //单价
        //             nowLaborItem_unitSumPrice: '', //合价
        //             nowLaborItem_bidPrice: '', //中标裸税单价
        //             nowLaborItem_bidSumPrice: '', //中标裸税合价
        //             nowLaborItem_taxRate: '', //税率
        //             nowLaborItem_unitPriceType: '', //正式单价
        //             nowLaborItem_unitPriceTypeBool: '', //是否是正式单价

        //             nowMachineItem_remark: '',    //备注
        //             nowMachineItem_subCategoryName: '',//细目名称
        //             nowMachineItem_subCategoryNo: '', //细目编号
        //             nowMachineItem_unit: '',  //单位
        //             nowMachineItem_unitCount: '',//数量
        //             nowMachineItem_unitPrice: '', //单价
        //             nowMachineItem_unitSumPrice: '', //合价
        //             nowMachineItem_bidPrice: '', //中标裸税单价
        //             nowMachineItem_bidSumPrice: '', //中标裸税合价
        //             nowMachineItem_taxRate: '', //税率
        //             nowMachineItem_unitPriceType: '', //正式单价
        //             nowMachineItem_unitPriceTypeBool: '', //是否是正式单价

        //             nowMaterialItem_remark: '',    //备注
        //             nowMaterialItem_productName: '',// 存货名称
        //             nowMaterialItem_productNumber: '', //存货编码
        //             nowMaterialItem_model: '', //规格型号
        //             nowMaterialItem_unit: '',  //单位
        //             nowMaterialItem_unitCount: '',//数量
        //             nowMaterialItem_unitPrice: '', //单价
        //             nowMaterialItem_unitSumPrice: '', //合价
        //             nowMaterialItem_bidPrice: '', //中标裸税单价
        //             nowMaterialItem_bidSumPrice: '', //中标裸税合价
        //             nowMaterialItem_taxRate: '', //税率
        //             nowMaterialItem_unitPriceType: '', //正式单价
        //             nowMaterialItem_unitPriceTypeBool: '', //是否是正式单价

        //             nowOtherItem_remark: '',    //备注
        //             nowOtherItem_subCategoryName: '',//细目名称
        //             nowOtherItem_subCategoryNo: '', //细目编号
        //             nowOtherItem_unit: '',  //单位
        //             nowOtherItem_unitCount: '',//数量
        //             nowOtherItem_unitPrice: '', //单价
        //             nowOtherItem_unitSumPrice: '', //合价
        //             nowOtherItem_bidPrice: '', //中标裸税单价
        //             nowOtherItem_bidSumPrice: '', //中标裸税合价
        //             nowOtherItem_taxRate: '', //税率
        //             nowOtherItem_unitPriceType: '', //正式单价
        //             nowOtherItem_unitPriceTypeBool: '', //是否是正式单价
        //         }
        //         lengthNum += 1
        //     }
        // }
    })
    console.log(list)
    return list;
}

//设置表格合并
export function getJBXXTableData(detail) {
    let spanOneArr = [],
        concatOne = 0,
        spanTwoArr = [],
        concatTwo = 0;
    detail.forEach((item, index) => {
        if (index === 0) {
            //初始化第一行全部数据
            spanOneArr.push(1);
            spanTwoArr.push(1);
        } else {
            if (item.id === detail[index - 1].id) {
                //总包合同下细目名称相等的条件下，合并
                spanOneArr[concatOne] += 1;
                spanOneArr.push(0);
                //在细目名称相等的条件下，合作单位名称相等的合并
                if (item.partyBId === detail[index - 1].partyBId) {
                    spanTwoArr[concatTwo] += 1;
                    spanTwoArr.push(0);
                } else {
                    spanTwoArr.push(1);
                    concatTwo = index;
                }
            } else {
                //总包合同下细目名称不相等的条件下，不合并
                spanOneArr.push(1);
                concatOne = index;
                //在细目名称不相等的条件下，合作单位名称不合并
                spanTwoArr.push(1);
                concatTwo = index;
            }

        }
    });
    return {
        one: spanOneArr,
        two: spanTwoArr,
    }
}
